import React, { useEffect, useState } from 'react'
import System from 'src/helper/system';
import noImage from "src/assets/images/noimage.png";
import ProductLegends from '../ProductListing/ProductLegends';
import closeic from "src/assets/images/close-ic.png";
import useReduxState from 'src/hooks/useReduxState';
import HelperAnalyticsEvent from 'src/support/HelperAnalyticsEvent';
import NavigateToProductDetail from 'src/component/custom/NavigateToProductDetail';
import Helper from 'src/helper/Helper';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';

const QuoteCartList = () => {
    const { storageName: { QUOTE_CART_LIST }, avUserInfoData: { speedBoatNameLower } } = System
    const [quoteList, setQuoteList] = useReduxState(JSON.parse(sessionStorage.getItem(QUOTE_CART_LIST)), 'QuoteCartList')
    const [isFirstCall, setIsFirstCall] = useState(true);
    const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();

    useEffect(() => {
        sessionStorage.removeItem(System.storageName.SUCCESS_PAGE)
        if (isFirstCall) {
            HelperAnalyticsEvent.quoteCartEvent({ quoteCartDetails: quoteList, event: "quoteCartView" })
            setIsFirstCall(false)
        }
        system_alert_indicator({
            name: "QuoteCartMessage",
            message: 'Leaving this page will remove all items from your cart and return the items to Approved status.',
            type: "info",
            isDisplay: true,
        });
    }, [])

    return (
        <>
            <div className="col-auto mt-3">
                <div className="page-title font-oswald font-light font-38">
                    QUOTE CART SUMMARY
                </div>
            </div>
            <div className={"pt-2 pb-2"}>
                <div className="bs5 row">
                    <div className="col-12 text-end">
                        <a style={{ cursor: 'pointer' }} className="text-blue" data-toggle="modal" data-target="#CartClearAll"
                            onClick={() => {
                                System.popup('ClearQuoteCart', { currentCartItem: quoteList[0], clearAllCart: true })
                            }}><b>Clear Cart</b></a>
                    </div>
                </div>
            </div>
            <div className="bs5 row">
                <div className="col-12">
                    <div className="cart-list-table table-responsive quote-cart-table">
                        <table className="table" >
                            <tbody>
                                {quoteList?.length > 0 &&
                                    quoteList?.map((v, i) => (
                                        <React.Fragment key={i}>
                                            <tr key={i}
                                                className={v?.NCNRFlag ? "ncnr" : "non-ncnr"}
                                            >
                                                <td className="cart-list-product-img">
                                                    <div className="product-info nopadding">
                                                        <span>item: {i + 1}</span>
                                                        <div className="product-img sect-1 text-center">
                                                            <img alt="Product"
                                                                src={v.assetURL ? v.assetURL : noImage} />
                                                        </div>
                                                        <div className="prod-option-icon sect-2 d-flex flex-wrap">
                                                            <ProductLegends single_product={v}
                                                                onlyIcon={true} />
                                                        </div>
                                                    </div>
                                                </td>
                                                <td className="cart-list-product-detail">
                                                    <div className="d-flex">
                                                        <div className="product-detail">
                                                            <div className='product-name mb-2'>
                                                                <div className="d-flex align-items-center">
                                                                    <span className="me-1">
                                                                        <NavigateToProductDetail
                                                                            data={{ SEOManufacturerName: v?.SEOManufacturerName, SEOERPMFRPartNumber: v?.SEOERPMFRPartNumber, ItemNumber: v?.itemNumber, ERPPartNumber: v?.partNumber }}>
                                                                            <strong>{v.erpMfrPartNumber ? v.erpMfrPartNumber : ''}</strong>
                                                                        </NavigateToProductDetail>
                                                                    </span>
                                                                </div>
                                                                <div className="text-black-stone cursor-default">
                                                                    <div className="d-inline text-wrap w-auto">by&nbsp;</div>
                                                                    <a
                                                                        href={`/${speedBoatNameLower}/manufacturers/m/${Helper.replaceSpecialChar(v.erpManufacturerName?.toLowerCase())}/`}
                                                                        className="text-blue cursor-pointer"
                                                                    >
                                                                        {v?.erpManufacturerName}
                                                                    </a>

                                                                    {v?.SoftwareDownloadFlag && <span className="d-flex text-darkgreen w-100">
                                                                        <b>In Stock downloadable</b>
                                                                    </span>}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {v?.isProductAvailableFromMainAPI !== false &&
                                                            <div className="price-table-list ms-auto">
                                                                <div className="bs5 row">
                                                                    <div className="col-6">
                                                                        <span>Quantity:</span>
                                                                    </div>
                                                                    <div className="col-6 text-end font_bold_currency">
                                                                        <span>
                                                                            {v.quantity}
                                                                        </span>
                                                                    </div>
                                                                </div>

                                                                <div className="bs5 row">
                                                                    <div className="col-6">
                                                                        <span>Quantity Unit Price:</span>
                                                                    </div>
                                                                    <div className="col-6 text-end font_bold_currency">
                                                                        <span>
                                                                            {System.getFormatNumber({ amount: Number(v.unitPrice) })}
                                                                        </span>
                                                                    </div>
                                                                </div>

                                                                <div className="bs5 row">
                                                                    <div className="col-6">
                                                                        <span>*Additional Charges1:</span>
                                                                    </div>
                                                                    <div className="col-6 text-end font_bold_currency">
                                                                        <span>
                                                                            {v.additionalCharge1 ? System.getFormatNumber({ amount: Number(v.additionalCharge1) }) : '-'}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className="bs5 row">
                                                                    <div className="col-6">
                                                                        <span>*Additional Charges2:</span>
                                                                    </div>
                                                                    <div className="col-6 text-end font_bold_currency">
                                                                        <span>
                                                                            {v.additionalCharge2 ? System.getFormatNumber({ amount: Number(v.additionalCharge2) }) : '-'}
                                                                        </span>
                                                                    </div>
                                                                </div>

                                                                <div className="bs5 row">
                                                                    <div className="col-6">
                                                                        <span>Subtotal:</span>
                                                                    </div>
                                                                    <div className="col-6 text-end font_bold_currency">
                                                                        <span>
                                                                            {System.getFormatNumber({ amount: v.subtotal })}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                </td>
                                                <td className="cart-list-close">
                                                    <div onClick={() => { System.popup('ClearQuoteCart', { currentCartItem: v }) }}>
                                                        <div className="close-ic">
                                                            <img src={closeic} alt="Close" />
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="cart-list-error"></td>
                                                <td colSpan={3} className="cart-list-error">
                                                    {(v?.NCNRFlag) && (
                                                        <div className="alert alert-dark ncnr-alert justify-content-center">
                                                            <b>NCNR:</b> <span>Non-Cancelable/Non-Returnable</span>
                                                        </div>
                                                    )}
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )
}

export default QuoteCartList